<template>
          <div class="choices">
            <div class="choice" v-for="choice,choiceIndex in question.answers_multiple" :class="{'selected': choice.selected, 'correct': choice.is_correct && question.commited,'incorrect': !choice.is_correct && question.commited  }">
              <button :disabled="question.commited"  @click="selectMultiAnswer(question,choiceIndex)">{{String.fromCharCode(choiceIndex+65)}}</button>
              <span v-html="choice.answer"></span>
            </div>
            <div v-if="question.commited && question.correct && paid" class="congratulations">
              Your answer is correct!
            </div>
            <div v-if="question.commited && !question.correct && paid" class="sorry">
              Your answer is incorrect. Correct answer is {{currentQuestionAnswer}}
            </div>
            <div v-if="question.commited && !paid">Answer submitted. Click Continue to proceed.</div>
            <button v-if="!question.commited" @click="answerMultipleChoice(question)">Submit</button>
            <button v-if="question.commited && question.explanation_input" @click="showExplanation=true">Show Explanation</button>
          </div>
</template>

<script>
import Vue from 'vue'
    export default {
          name: 'multi-multi',
          props: ['question', 'paid'],
          data(){
            return {

            }
          },
          methods:{
            selectMultiAnswer: function(question, choiceIndex){
              var vm = this;
              vm.question.answers_multiple[choiceIndex].selected = !question.answers_multiple[choiceIndex].selected;
              Vue.set(question.answers_multiple, choiceIndex, vm.question.answers_multiple[choiceIndex]);
            },
            answerMultipleChoice: function(question){
                console.log('emitting answer');
                this.$emit('answer', {question} );
            }
          },
          computed: {
                currentQuestionAnswer: function(){
                  var vm = this;
                  var question = vm.question;

                  console.log('question', question);
                  var answerArray = [];

                  for (var i = 0; i < question.answers_multiple.length; i++) {
                      console.log(question.answers_multiple[i]);
                      if(question.answers_multiple[i].is_correct)
                        answerArray.push(String.fromCharCode(i+65));
                      //Do something
                  }

                  return answerArray.join(', ');


            }
          }
    }
</script>


// WEBPACK FOOTER //
// MultipleChoiceMultiAnswer.vue?04a6743e